import { supabase } from '../../../src/lib/supabase';
import { UcParaRateio } from '../../../src/hooks/useRateioBalanceamento';

// Terceiro alerta da tela — saldo de crédito abaixo de 1 mês de cobertura. Mora
// em `coberturaSaldo.ts` e não aqui porque o `import` do cliente Supabase logo
// acima tornaria a regra impossível de rodar em `node --test` sem subir
// rede/env (mesmo motivo que separou `mesReferenciaRateio.ts` de
// `consumoHistorico.ts`). A reexportação mantém os três alertas do rateio
// acessíveis por um único módulo.
export {
  avaliarCoberturaSaldo,
  mapearCoberturaSaldo,
  detectarSaldoBaixo,
  COBERTURA_MINIMA_SAUDAVEL_MESES,
  COBERTURA_MAXIMA_SAUDAVEL_MESES,
  SITUACOES_SEM_INJECAO,
  type CoberturaSaldo,
} from './coberturaSaldo';

const soDigitos = (v: unknown): string => (typeof v === 'string' ? v.replace(/\D/g, '') : '');

/**
 * Divergência simples (Seção 12 — "Troca de titularidade detectada"): compara o
 * CPF/CNPJ extraído da última fatura (cpf_cnpj_titular) com o CPF/CNPJ cadastrado
 * (cpf_cnpj_cliente). Não rastreia histórico de mudança — só sinaliza que hoje os
 * dois divergem, enquanto ambos estiverem preenchidos.
 */
export function detectarTitularidadeDivergente(ucs: UcParaRateio[]): UcParaRateio[] {
  return ucs.filter(uc => {
    const titular = soDigitos(uc.cpf_cnpj_titular);
    const cliente = soDigitos(uc.cpf_cnpj_cliente);
    return titular.length > 0 && cliente.length > 0 && titular !== cliente;
  });
}

/**
 * Créditos duplicados (Seção 12 — "Conflito"): a mesma UC aparece nos itens de um
 * rateio protocolado/conciliado de OUTRA UG para o mesmo mês de referência —
 * sinal de que o crédito pode estar sendo reivindicado duas vezes junto à
 * distribuidora (ex.: UC trocou de UG no meio do ciclo).
 */
export async function detectarCreditosDuplicados(
  ucIds: number[],
  ugIdAtual: string,
  mesReferencia: string
): Promise<Set<number>> {
  const resultado = new Set<number>();
  if (ucIds.length === 0) return resultado;

  const { data, error } = await supabase
    .from('rateio_itens')
    .select('unidade_consumidora_id, rateios!inner(mes_referencia, status, rateio_unidade_geradora_id)')
    .in('unidade_consumidora_id', ucIds)
    .eq('rateios.mes_referencia', mesReferencia)
    .in('rateios.status', ['protocolado', 'conciliado'])
    .neq('rateios.rateio_unidade_geradora_id', ugIdAtual);

  if (error) throw error;

  for (const item of data || []) {
    resultado.add((item as any).unidade_consumidora_id);
  }
  return resultado;
}
